import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import useSignalR from './useSignalR';
import { load as loadCart } from './Actions/Cart.action';
import { updateSavedCartRowAddStatus } from './Actions/SavedCart.action';

const SignalR = () => {
  const dispatch = useDispatch();
  const hubUrl = '/signalRHub';

  const handleCreateLine = (createLine) => {
    console.log('createLine', createLine);
    dispatch(loadCart());
    if (createLine && createLine.savedCartOrderRowId) {
      dispatch(updateSavedCartRowAddStatus(createLine));
    }
  };

  useSignalR(hubUrl, {
    CreateLine: handleCreateLine,
  });
  return <Fragment></Fragment>;
};

export default SignalR;
